const livingMainPeople = (flr) => {

  const pageWellnessLiving = document.getElementById('pageWellness-living');
  if (pageWellnessLiving) {


    let secMain = document.getElementById('jsSecMain');
    let jsPeople;

    if (flr == '1f') {
      jsPeople = secMain.querySelectorAll('.js-people-box-1f');
    } else if (flr == '2f') {
      jsPeople = secMain.querySelectorAll('.js-people-box-2f');
    }


    // console.log(jsPeople);


    const moveStart = (elem) => {
      let i = elem.querySelector('i');
      i.className = 'act'
    }
    const moveStop = (elem) => {
      let i = elem.querySelector('i');
      i.classList.add('stop');
    }
    const moveReset = (elem) => {
      elem.classList.remove('act')
      let i = elem.querySelector('i');
      setTimeout(() => {
        i.classList.remove('act')
      }, 1000)
    }

    const moveLoop = (elem, time, func) => {
      let diff = 3000
      elem.classList.add('act')
      moveStart(elem)

      if (time !== 0) {
        setTimeout(() => {
          moveStop(elem)
        }, time)
        setTimeout(() => {
          moveReset(elem)
        }, time + diff)
        setTimeout(() => {
          func()
        }, time + diff * 2)
      }
    }


    if (flr == '1f') {

      const people0 = () => {
        let elem = jsPeople[0]
        let time = 0
        moveLoop(elem, time, people0)
      }
      people0()

      const people4 = () => {
        let elem = jsPeople[4]
        let time = 0
        moveLoop(elem, time, people4)
      }
      people4()

      const people5 = () => {
        let elem = jsPeople[5]
        let time = 0
        moveLoop(elem, time, people5)
      }
      people5()

      const people9 = () => {
        let elem = jsPeople[9]
        let time = 10400
        moveLoop(elem, time, people9)
      }
      people9()

      const people17 = () => {
        let elem = jsPeople[17]
        let time = 21600
        moveLoop(elem, time, people17)
      }
      people17()

      const people19 = () => {
        let elem = jsPeople[19]
        let time = 0
        moveLoop(elem, time, people19)
      }
      people19()

    } else if (flr == '2f') {

      const people0 = () => {
        let elem = jsPeople[0]
        let time = 0
        moveLoop(elem, time, people0)
      }
      people0()

      const people9 = () => {
        let elem = jsPeople[9]
        let time = 10400
        moveLoop(elem, time, people9)
      }
      people9()

      const people15 = () => {
        let elem = jsPeople[15]
        let time = 0
        moveLoop(elem, time, people15)
      }
      people15()

      const people19 = () => {
        let elem = jsPeople[19]
        let time = 27000
        moveLoop(elem, time, people19)
      }
      people19()

      const people20 = () => {
        let elem = jsPeople[20]
        let time = 27000
        moveLoop(elem, time, people20)
      }
      people20()

      const people21 = () => {
        let elem = jsPeople[21]
        let time = 21600
        moveLoop(elem, time, people21)
      }
      people21()

      const people28 = () => {
        let elem = jsPeople[28]
        let time = 0
        moveLoop(elem, time, people28)
      }
      people28()

    }


  }

}
export default livingMainPeople;